const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  faceSizeSelection: 'face-size-selection',
  closeCliponModal: 'close-clipon-modal',
  startTryOn: 'start-try-on',
  searchSubmit: 'search-submit',
  accountCreated: 'account-created',
  VMMVAvailability: 'vmmv-availability',
  updateWishlist: 'update-wishlist',
  wishlistLoaded: 'wishlist-loaded'
};

const FACE_SIZE_RANGE = {
  narrow: { key: 'narrow', min: 111, max: 128 },
  average: { key: 'average', min: 123, max: 138 },
  wide: { key: 'wide', min: 133, max: 150 }
}

const WISHLIST_CONSTANTS = {
  localStorageKey: 'wishlist',
  customerStorageKey: 'wishlist_customer_id',
  eventKeyAdd: 'add',
  eventKeyRemove: 'remove'
}
